import { Box } from '@mui/material'
import { FC } from 'react'

interface FloatingBoxProps {
  onClick: (num: number) => void
  number: number
  boxColor: string
  colorSet: {
    color: string
    boxShadow: string
    transform: string
    animation: string
    cursor: string
    filter: string
    transformHover: string
    boxShadowHover: string
  }
}

export const FloatingBox: FC<FloatingBoxProps> = ({ number, onClick, boxColor, colorSet }) => {

  return (
    <Box
      onClick={() => onClick(number)}
      sx={{
        width: { xs: 28, md: 32 },
        height: { xs: 28, md: 32 },
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 0.5,
        backgroundColor: boxColor,
        color: colorSet.color,
        boxShadow: colorSet.boxShadow,
        transform: colorSet.transform,
        transition: 'transform 0.2s, box-shadow 0.2s',
        animation: colorSet.animation,
        cursor: colorSet.cursor,

        '&:hover': {
          backgroundColor: boxColor,
          filter: colorSet.filter,

          animation: 'none',
          transform: colorSet.transformHover,
          boxShadow: colorSet.boxShadowHover,
        },
        fontSize: { xs: '13px', md: '14px' },
        flexShrink: 0,
      }}
    >
      {number}
    </Box>
  )
}
